// @flow

import ApiError from 'PMT/entities/ApiError'
import CartModifier from 'PMT/entities/menu/CartModifier'
import ReduceStore from 'PMT/flux/ReduceStore'
import ArrayUtils from 'PMT/utils/ArrayUtils'

import ActionTypes from 'constants/ActionTypes'

class CartModifierListStore extends ReduceStore {

  getInitialState() {
    return {
      data: [ new CartModifier() ],
      apiError: null,
      isFetching: false,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      data: [],
      isFetching: false,
    }
  }

  getState() {
    return this._state
  }

  reduce(state, action, nextState) {
    switch(action.type) {
      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState()

      case ActionTypes.GET_CART_MODIFIERS:
        nextState.isFetching = true
        nextState.apiError = null
        nextState.data = null
        return nextState

      case ActionTypes.GET_CART_MODIFIERS_SUCCESS:
        nextState.isFetching = false
        nextState.apiError = null
        nextState.data = action.data
        return nextState

      case ActionTypes.GET_CART_MODIFIERS_FAILURE:
        nextState.isFetching = false
        nextState.data = null
        nextState.apiError = action.apiError
        return nextState

      case ActionTypes.PUT_CART_MODIFIER:
        // TODO: fix nextState considered as equal
        nextState.data = ArrayUtils.updateObjectOrAdd(
          nextState.data,
          new CartModifier().fromJson({ ...action.cartModifier, isFetching: true }),
          (cartModifier) => {
            return cartModifier.id === action.cartModifier.id
          })
        return nextState

      case ActionTypes.PUT_CART_MODIFIER_SUCCESS:
        // TODO: fix nextState considered as equal
        nextState.data = ArrayUtils.updateObjectOrAdd(
          nextState.data,
          new CartModifier().fromJson({ ...action.data, isFetching: false }),
          (cartModifier) => {
          return cartModifier.id === action.data.id
        })
        return nextState

      case ActionTypes.PUT_CART_MODIFIERS_PRIORITIES:
        nextState.isFetching = false
        nextState.apiError = null
        return nextState

      case ActionTypes.PUT_CART_MODIFIERS_PRIORITIES_SUCCESS:
        // TODO: update data instead of replacing it
        nextState.data = action.data
        return nextState

      case ActionTypes.PUT_CART_MODIFIERS_PRIORITIES_FAILURE:
        nextState.apiError = action.apiError
        return nextState

      default:
        return nextState
    }
  }

}

export default new CartModifierListStore()



// WEBPACK FOOTER //
// ./scripts/stores/CartModifierListStore.js